import { theme } from '@noths/polaris-client-ribbons-base';
import { css } from 'styled-components';

const { spacing } = theme;

export const navigationButton = css`
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
  width: 44px;
  height: 44px;
  background-color: var(--neutral-white-base);
  border: none;
  border-radius: 50%;
  padding: 10px;

  &.focus-visible {
    outline: none;

    &:before {
      content: '';
      position: absolute;
      top: -4px;
      bottom: -4px;
      left: -4px;
      right: -4px;
      border-radius: 50%;
      border: var(--brand-purple-base) 2px solid;
    }

    &:after {
      content: '';
      position: absolute;
      top: -6px;
      bottom: -6px;
      left: -6px;
      right: -6px;
      border-radius: 50%;
      border: var(--neutral-black-10) 2px solid;
    }
  }
`;

export const prevNavigationButton = css`
  left: ${spacing.md}px;

  img {
    transform: rotate(180deg);
  }
`;

export const nextNavigationButton = css`
  right: ${spacing.md}px;
`;
